export function pumpGetSymbol(eventType = 'Carbs') {
  /* eslint-disable */
  switch(`${eventType}`.trim().toLowerCase()) {
  case `reservoir`:
    return `image://https://static.pancares.com/pancares-report/svg/pumpicon-resovior3.svg`
  case `changemodule`:
    // return `image://https://static.pancares.com/pancares-report/svg/changeModule-withline.svg`
    return `image://https://static.pancares.com/pancares-report/svg/changeModule.svg`
  case 'carbs':
    return `image://https://static.pancares.com/pancares-report/svg/apple.svg`
  case 'alarm':
    return `image://https://static.pancares.com/pancares-report/svg/pumpicon-alarm3.svg`
  case 'needle':
    return `image://https://static.pancares.com/pancares-report/svg/pumpicon-needle.svg`
  case 'clock':
    return `image://https://static.pancares.com/pancares-report/svg/pumpicon-clock.svg`
  case 'upload':
    return `image://https://static.pancares.com/pancares-report/svg/pumpicon-upload2.svg`
  case '':
    return ''
  default:
    console.error(`pumpGetSymbol,无法获取${eventType}的图标`)
    return 'pin'
  }
  /* eslint-enable */
}
